import { httpGet } from './apiService';
import { CarouselResult } from '@models/section/cardCarouselSection';

const categoryBaseApiUrl = '/api/category';

export async function getCarouselByCategory(categoryId: number): Promise<CarouselResult> {
    return (await httpGet(`${categoryBaseApiUrl}/carousel/${categoryId}`)).json();
}
